import { render, staticRenderFns } from "./xinyan-probe.vue?vue&type=template&id=bfc4e774&scoped=true"
import script from "./xinyan-probe.vue?vue&type=script&lang=js"
export * from "./xinyan-probe.vue?vue&type=script&lang=js"
import style0 from "./xinyan-probe.vue?vue&type=style&index=0&id=bfc4e774&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc4e774",
  null
  
)

export default component.exports